import React from "react";
import SubscriptionPricingCard from "../../Seller-Owner/Components/SubscriptionPricingCard";
import "../styles/PlainTimerPage.css";

const PlainTimerPage = () => {
  return (
    <div className="seller-timer-page">
      <div className="seller-timer-content">
        <div className="seller-timer-pricing-section">
          <h2 className="seller-timer-pricing-heading">Plans &amp; pricing</h2>
          <SubscriptionPricingCard variant="page" dashboardBasePath="/agent-dashboard" />
        </div>
      </div>
    </div>
  );
};

export default PlainTimerPage;
